import { Formik } from 'formik';
import React from 'react';
import styled from 'styled-components';
import { CustomHeader } from '../CustomHeader';
import { CommonHeader } from '../CommonHeader';
import { formInitialValues, validationSchema } from '../formikConstants';
import { FormWithScrollToErrors } from '../FormWithScrollToErrors';
import { Footnote } from '../Footnote';
import media from '../../../../utils/mediaQueries';
import { LINKS_COLOR, NOTES_COLOR } from '../../../../theme';
import { ReviewFormType } from '../types';
import { FORM_TEXTS } from '../formDictionary';

const Body = styled.div`
  padding: 24px 40px 32px;

  ${media.mobile`
    padding: 16px 24px 24px;
  `}
  a {
    color: ${LINKS_COLOR};
  }
`;

const FormTitle = styled.h4`
  font-size: 18px;
  font-weight: 800;
  line-height: 1.44;
  letter-spacing: 0.2px;
  margin-bottom: 10px;
`;

const Note = styled.div`
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: ${NOTES_COLOR};
  margin-bottom: 24px;

  ${media.mobile`
    font-size: 12px;
  `}
`;

const FootnoteRow = styled.div`
  margin-top: 24px;
`;

const HighResolution = ({
  isCustomTheme,
  firstName,
  type,
  examCenterLogo,
  examCenterAddress,
  examCenterTitle,
  onFormSubmit,
  reviewTextRef,
}: ReviewFormType) => {
  const { title, titleNote } = FORM_TEXTS;

  return (
    <>
      {
        isCustomTheme
          ? <CustomHeader name={firstName} type={type} />
          : (
            <CommonHeader
              examCenterLogo={examCenterLogo}
              examCenterAddress={examCenterAddress}
              examCenterTitle={examCenterTitle}
            />
          )
      }
      <Body>
        <FormTitle>{title}</FormTitle>
        <Note>{titleNote}</Note>
        <Formik
          initialValues={formInitialValues}
          onSubmit={onFormSubmit}
          validationSchema={validationSchema}
        >
          <FormWithScrollToErrors reviewTextRef={reviewTextRef} />
        </Formik>
        <FootnoteRow>
          <Footnote />
        </FootnoteRow>
      </Body>
    </>
  );
};

export { HighResolution };
